export default {
  h1: {
    fontWeight: "normal",
    fontSize: 35,
    fontFamily: "'Orbitron', sans-seri",
    lineHeight: "62px",
  },
  h2: {
    fontFamily: "'Orbitron', sans-seri",
    fontWeight: "bold",
    fontSize: "50px",
    lineHeight: " 63px",
  },
  h3: {
    fontWeight: 500,
    fontSize: 25,
    fontFamily: "'Orbitron', sans-seri",
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    fontFamily: "'Orbitron', sans-seri",
  },
  h5: {
    fontWeight: 500,
    fontSize: 18,
    fontFamily: "'Orbitron', sans-seri",
  },
  h6: {
    // fontWeight: 500,
    lineHeight: "21px",
    fontSize: 18,
    fontFamily: "'Roboto', sans-serif",
  },
  overline: {
    fontWeight: 500,
  },
  button: {
    textTransform: "capitalize",
    borderRadius: 27,
    fontFamily: "'Orbitron', sans-seri",
  },
  body1: {
    fontSize: 16,
    lineHeight: "30px",
    fontFamily: "'Roboto', sans-serif",
  },
};
